<p class="text-preview">
  {{ content }}
</p>
<a *ngIf="toggleAllowed && !isContentToggled" (click)="toggleContent()" class="link">Leia mais</a>
<a *ngIf="toggleAllowed && isContentToggled" (click)="toggleContent()" class="link">Leia menos</a>
